import { Hand, PackageCheck, Truck } from "lucide-react";

export const FULFILLMENT = {
  take_now: { label: "Take Now", short: "Now", icon: Hand, cls: "bg-emerald-600 text-white border-emerald-600", receipt: "Collected Now" },
  pickup: { label: "Hold for Pickup", short: "Hold", icon: PackageCheck, cls: "bg-amber-500 text-white border-amber-500", receipt: "Awaiting Pickup" },
  delivery: { label: "Delivery / Special Order", short: "Deliver", icon: Truck, cls: "bg-sky-600 text-white border-sky-600", receipt: "Awaiting Delivery" },
};

export const defaultFulfillment = (track) => (track ? "take_now" : "delivery");

// Compact 3-way per-line control: one tap changes the method, no dialogs.
export function FulfillmentPicker({ value, onChange, id, size = "sm" }) {
  const pad = size === "xs" ? "h-6 px-1.5 text-[10px]" : "h-7 px-2 text-[11px]";
  return (
    <div className="inline-flex rounded-md border border-border overflow-hidden" role="radiogroup" data-testid={`fulfillment-picker-${id}`}>
      {Object.entries(FULFILLMENT).map(([k, f]) => {
        const on = value === k;
        return (
          <button key={k} type="button" title={f.label} aria-checked={on} role="radio"
            onClick={() => onChange(k)} data-testid={`fulfillment-${k}-${id}`}
            className={`inline-flex items-center gap-1 font-semibold transition-colors ${pad} ${on ? f.cls : "bg-background text-muted-foreground hover:bg-secondary"}`}>
            <f.icon className="w-3 h-3" /> {f.short}
          </button>
        );
      })}
    </div>
  );
}
